module.exports = __webpack_public_path__ + "img/kulian.9081d3d2.png";